import { useEffect, useState } from "react";
import { IS_PROD, IS_XSOLA } from "util/constants";

const LOG_TAG = 'Auth check error: ';
const AUTH__TOKEN_ROUTE = '/api/custom-auth-validate-token';
const IS_DISABLED_AUTH = !IS_PROD || IS_XSOLA;

export default function useIsLoggedIn() {
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(true);

    useEffect(() => {
        const checkAuth = async () => {
          if(IS_DISABLED_AUTH) { 
            setIsLoggedIn(true);
            return;  
          }

          try {
            const res = await fetch(AUTH__TOKEN_ROUTE, {
              credentials: 'include', // Send cookies
            });
    
            if (!res.ok) {
                setIsLoggedIn(false);
                return;
            }

            setIsLoggedIn(true);
          } catch (err) {
            console.error(LOG_TAG, err);
            setIsLoggedIn(false);
          }
        };
    
        checkAuth();
    }, []);
    

    return {
        isLoggedIn,
    }
}